export default __webpack_public_path__ + "static/media/elbow.8521aada.svg";